var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCctvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 119.76",
    style: {
      enableBackground: "new 0 0 122.88 119.76"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.5,0.2L19.1,24.97l30.23,39.5l69.77-19.78c2.74-0.78,4.35-3.66,3.57-6.4L112.9,3.77 C112.12,1.03,109.24-0.58,106.5,0.2L106.5,0.2L106.5,0.2z M83.88,64.13l-16.25,3.82v51.81l16.25,0V64.13L83.88,64.13z M34.65,61.37 L15.89,33.39L0,37.89l18.94,27.93L34.65,61.37L34.65,61.37L34.65,61.37z M55.73,30.54l-8.14,2.31l2.61,9.21l8.14-2.31L55.73,30.54 L55.73,30.54L55.73,30.54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctvIcon);
export default __webpack_public_path__ + "static/media/cctv-icon.03819a01338d3be85c135b6715b4860d.svg";
export { ForwardRef as ReactComponent };